<template>
  <div class="xc-page">
    <div class="xc-page-main">
      <!-- 面包屑 -->
      <div class="xc-breadcrumb">
        <router-link :to="$config.adminPath + '/system/account/setting'">账号设置</router-link>
        <a>基本信息</a>
      </div>
      <div class="xc-row xc-s-flex">
        <div class="xc-card">
          <div class="xc-card-content">
            <form name="account" class="xc-form" data-vv-scope="account">
              <div class="xc-info">
                <div class="xc-info-header">
                  <div class="xc-info-title">基本信息</div>
                </div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <xc-form-item label="登录账号：">
                      <!-- <input
                                                type="text"
                                                name="userName"
                                                :value="user.userName"
                                                class="xc-input xc-input-disabled"
                                                disabled
                      />-->
                      <p class="xc-input text-height">{{user.userName}}</p>
                    </xc-form-item>
                    <xc-form-item label="注册时间：">
                      <!-- <input
                                                type="text"
                                                name="addTime"
                                                :value="user.addTime"
                                                class="xc-input xc-input-disabled"
                                                disabled
                      />-->
                      <p class="xc-input text-height">{{user.addTime}}</p>
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline">
                    <xc-form-item label="账号名称：">
                      <input
                                                type="text"
                                                name="nickName"
                                                v-model="user.nickName"
                                                class="xc-input"
                      />
                      <!-- <p class="xc-input text-height">{{user.nickName}}</p> -->
                    </xc-form-item>
                    <xc-form-item label="性别：">
                      <label class="xc-checkbox-wrap">
                        <input
                          type="radio"
                          name="gender"
                          class="xc-radio"
                          value="男"
                          v-model="user.gender"
                        />
                        <span class="xc-checkbox-label">男</span>
                      </label>
                      <label class="xc-checkbox-wrap">
                        <input
                          type="radio"
                          name="gender"
                          class="xc-radio"
                          value="女"
                          v-model="user.gender"
                        />
                        <span class="xc-checkbox-label">女</span>
                      </label>
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline">
                    <xc-form-item label="头像：">
                      <xc-upload :fileList.sync="files" type="3" accept="image/*" :url="uploadUrl" />
                    </xc-form-item>
                  </div>
                </div>
              </div>
              <div class="xc-info">
                <div class="xc-info-header">
                  <div class="xc-info-title">安全设置</div>
                </div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <xc-form-item label="登录密码：">
                      <!-- <input
                                                type="password"
                                                name="password"
                                                class="xc-input xc-input-disabled"
                                                disabled
                                                value="123456"
                      />-->
                      <div>
                        <p class="xc-input text-height ele-float">******</p>
                        <label class="xc-link ele-float">
                          <a @click="edit" class="text-height">修改</a>
                        </label>
                        <div class="null-box"></div>
                      </div>
                    </xc-form-item>
                    <xc-form-item label="手机号码：" :error="errors.first('mobilePhone','account')">
                      <input
                          type="tel"
                          name="mobilePhone"
                          v-validate="'required|mobile'"
                          data-vv-as="手机号码"
                          v-model="user.mobilePhone"
                          class="xc-input xc-input-readonly"
                          style="border-width: 0; padding: 0"
                          readonly
                      />
                      <!-- <p class="xc-input text-height">{{user.mobilePhone}}</p> -->
                    </xc-form-item>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="xc-page-footer">
      <div class="xc-btn-group">
        <button type="button" class="xc-btn xc-btn-primary" @click="save">保存</button>
      </div>
    </div>
    <div class="xc-card">
      <template v-if="user">
        <div class="xc-modal xc-modal-dialog" v-if="modalName=='reset'">
          <div class="xc-modal-mask" @click="modalName=null"></div>
          <div class="xc-modal-wrap xc-anim-scaleIn">
            <div class="xc-modal-content">
              <div class="xc-modal-header">
                <div class="xc-modal-title">修改密码</div>
                <div class="xc-modal-close" @click="modalName=null"></div>
              </div>
              <div class="xc-modal-body xc-flex-center">
                <form class="xc-form" name="reset" data-vv-scope="reset">
                  <div class="xc-form-inline">
                    <xc-form-item label="旧登录密码：" required :error="errors.first('oldPwd','reset')">
                      <input
                        type="password"
                        name="oldPwd"
                        class="xc-input"
                        placeholder="请输入旧登录密码"
                        v-validate="'required'"
                        data-vv-as="旧登录密码"
                      />
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline">
                    <xc-form-item label="新登录密码：" required :error="errors.first('newPwd','reset')">
                      <input
                        type="password"
                        name="newPwd"
                        class="xc-input"
                        placeholder="请输入新登录密码"
                        v-validate="'required|alpha_num|min:6|max:20'"
                        data-vv-as="新登录密码"
                      />
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline">
                    <xc-form-item label="确认密码：" required :error="errors.first('confirm','reset')">
                      <input
                        type="password"
                        name="confirm"
                        class="xc-input"
                        placeholder="请输入确认密码"
                        v-validate="'required|alpha_num|min:6|max:20'"
                        data-vv-as="确认密码"
                      />
                    </xc-form-item>
                  </div>
                </form>
              </div>
              <div class="xc-modal-footer xc-flex-center">
                <div class="xc-btn-group">
                  <button type="button" class="xc-btn xc-btn-default" @click="modalName=null">取消</button>
                  <button type="button" class="xc-btn xc-btn-primary" @click="reset">确认</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import "@/libs/vee-validate";
import "@/utils/form-format";
import loadScript from "@/utils/load-script";
import userInfo from "@/api/user-info";
export default {
  name: "AccountSetting",
  data() {
    return {
      files: [],
      uploadUrl: "/uploadfile",
      user: {},
      modalName: null,
      adminPath: this.$config.adminPath
    };
  },
  async created() {
    await loadScript("/libs/md5.js");
    var _this = this;
    //    获取用户信息
    userInfo.base().then(function(success) {
      _this.user = success.data;
      if (success.data.avatar) {
        var obj = {
          file: success.data.avatar,
          url: success.data.avatar
        };
        _this.files.push(obj);
      }
    });
  },
  methods: {
    //修改基本信息
    save() {
      var _this = this;
      var myForm = document.account;
      this.$validator
        .validate("account.mobilePhone")
        .then(v => {
          if (v) {
            var account = this.$formFormat(myForm);
            return account;
          }
        })
        .then(formatData => {
          if (formatData) {
            var { gender, nickName, mobilePhone } = formatData;
            var obj = {
              gender: gender,
              nickName: nickName,
              mobilePhone: mobilePhone,
              avatar: ""
            };
            if (this.files.length) {
              obj.avatar = this.files[0].url;
            }
            userInfo.modify(obj).then(success => {
              _this.$message.success("修改成功");
              this.$store.dispatch("getUserInfo");
            });
          }
        });
    },

    edit() {
      this.modalName = "reset";
    },
    //修改密码
    reset() {
      var _this = this;
      var reset = document.reset;
      // 验证器命名空间
      const scope = "reset";

      this.$validator
        .validateAll(scope)
        .then(validate => {
          if (validate) {
            return _this.$formFormat(reset);
          } else {
            let error = this.errors.items[0].msg;
            return false;
            // this.$message.error(error)
          }
        })
        .then(formData => {
          if (formData) {
            let data = {};
            data.newPwd = formData.newPwd;
            data.oldPwd = formData.oldPwd;

            var verifyResult = this.checkPassword(data.newPwd);
            if (verifyResult != true) {
              this.$message.error(verifyResult);
              return false;
            }

            if (formData.newPwd != formData.confirm) {
              _this.$message.error("二次密码输入不一致");
              return;
            }

            data.oldPwd = window.md5(formData.oldPwd);
            data.newPwd = window.md5(formData.newPwd);

            //修改密码
            userInfo.changepwd(data).then(function(success) {
              _this.$message.success("修改密码成功");
              _this.modalName = null;
            });
          }
        });
    },

    /**
     * 密码验证
     * @param {String} 密码
     */
    checkPassword(v) {
      var numasc = 0;
      var charasc = 0;
      var otherasc = 0;
      if (0 == v.length) {
        return "密码不能为空";
      } else if (v.length < 6 || v.length > 20) {
        return "密码长度为6-20位，且同时包含数据和字母";
      } else {
        for (var i = 0; i < v.length; i++) {
          var asciiNumber = v.substr(i, 1).charCodeAt();
          if (asciiNumber >= 48 && asciiNumber <= 57) {
            numasc += 1;
          }
          if (
            (asciiNumber >= 65 && asciiNumber <= 90) ||
            (asciiNumber >= 97 && asciiNumber <= 122)
          ) {
            charasc += 1;
          }
          if (
            (asciiNumber >= 33 && asciiNumber <= 47) ||
            (asciiNumber >= 58 && asciiNumber <= 64) ||
            (asciiNumber >= 91 && asciiNumber <= 96) ||
            (asciiNumber >= 123 && asciiNumber <= 126)
          ) {
            otherasc += 1;
          }
        }
        if (0 == numasc || 0 == charasc) {
          return "密码长度为6-20位，且同时包含数据和字母";
        } else {
          return true;
        }
      }
    }
  }
};
</script>

<style scoped lang="css">
.xc-link {
  margin-left: 20px;
}

form[name="reset"] >>> .xc-form-item-label {
  width: 100px;
}

.text-height {
  line-height: 32px;
}

.ele-float {
  float: left;
}

.null-box {
  clear: both;
}
</style>
